import React, { useEffect, useMemo, useState } from 'react'
import Select from 'react-select';
import CustomColumn from '../../customControl/CustomColumn';
import CommonFilter from '../../customControl/CommonFilter';
import CustomTable from '../../customControl/CustomTable';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { getAllData, verifytoken } from '../../services/ApiCallingUserServices';
import { loaderActions } from '../../_actions/loader.actions';
import { formatDate } from '../commonClass/CommonValidation';
import { ClearLocalStorage } from '../commonClass/Session';
import secureLocalStorage from 'react-secure-storage';

const SEOPanelList = () => {

    const dispatch = useDispatch();
    const navigate = useNavigate();

    const user = useSelector(store => store.userstatus.tba);
    const [userRights, setUserRights] = useState({
        URightAdd: true,
        URightEdit: true,
        URightExport: true,
    });

    const [productList, setProductList] = useState([]);

    const [productId, setProductId] = useState(0);

    const [searchValue, setSearchValue] = useState("");
    const [searchby, setSerachBy] = useState('All');    // when no need of column dropdown for searching then fixed value as "All".
    const serchdisable = useMemo(() => {
        return productId <= 0;
    }, [productId])

    const [seoPanelListData, setSeoPanelListData] = useState([]);
    const [filterList, setFilterList] = useState([]);


    //#region handle rights
    useEffect(() => {
        if (user?.length > 0) {
            const pathName = window?.location?.pathname?.toLowerCase();
            const hasRights = user?.find(x => x?.PageLink?.toLowerCase() === pathName)
            if (!hasRights?.URightView) {
                navigate("/dashboard");
                return;
            }
            setUserRights({
                URightAdd: hasRights?.URightAdd,
                URightEdit: hasRights?.URightEdit,
                URightExport: hasRights?.URightExport,
            })
        }
    }, [user])
    //#endregion

    //#region API calling functions
    const getseopanellist = async (productId) => {
        const seopanellist = await getAllData(`/master/v1/getseopanellist?TravelCategoryId=${productId}`);
        if (seopanellist?.status) {
            seopanellist?.data?.map((obj, index) => {
                obj.SrNo = index + 1;
                obj.CreatedOnFormat = formatDate(obj?.createdOn);
                return obj;
            })
            setSeoPanelListData(seopanellist?.data ? seopanellist?.data : []);
            setFilterList(seopanellist?.data ? seopanellist?.data : []);
        }
        else {
            setSeoPanelListData([]);
            setFilterList([]);
        }
    }

    const gettravelcategorylist = async () => {
        const travelcategorylist = await getAllData("/master/v1/gettravelcategorylist");
        if (travelcategorylist?.status) {
            const productlist = [{ label: 'Select Product', value: 0 }, ...travelcategorylist?.data];
            setProductList(productlist)
        }
        else {
            setProductList([]);
        }
    }


    useEffect(() => {
        async function fetchData() {
            dispatch(loaderActions.start());
            const statusoftoken = await verifytoken();
            if (statusoftoken) {
                secureLocalStorage.setItem("seoconfigid", 0)
                Promise.allSettled([
                    gettravelcategorylist()
                ])
                dispatch(loaderActions.end());
            }
            else {
                ClearLocalStorage();
                dispatch(loaderActions.end());
                dispatch({ type: "SESSIONOUT", message: "Your Session Expired. Please Login Again!" })
            }
        }
        fetchData();
    }, [])
    //#endregion

    //#region handle product change function
    const handleOnChange = (value) => {
        setProductId(value);
        if (value > 0) {
            dispatch(loaderActions.start());
            Promise.allSettled([
                getseopanellist(value)
            ])
            dispatch(loaderActions.end());
        }
    }
    //#endregion


    //#region table columns
    const columns = [
        {
            name: 'Sr. No.',
            key: 'SrNo',
            sortable: true,
            reorder: true,
            float: "left",
            isSearch: true,
            isExport: true,
            selector: (el) => el?.SrNo
        },
        {
            name: 'Country',
            key: 'countryName',
            sortable: true,
            reorder: true,
            float: "left",
            isSearch: true,
            isExport: true,
            selector: (el) => el?.countryName
        },
        {
            name: 'State',
            key: 'stateName',
            sortable: true,
            reorder: true,
            float: "left",
            isSearch: true,
            isExport: true,
            selector: (el) => el?.stateName
        },
        {
            name: 'Package name',
            key: 'packageName',
            sortable: true,
            reorder: true,
            float: "left",
            isSearch: true,
            isExport: true,
            selector: (el) => el?.packageName
        },
        {
            name: 'Package Code',
            key: 'packageCode',
            sortable: true,
            reorder: true,
            float: "left",
            isSearch: true,
            isExport: true,
            selector: (el) => el?.packageCode
        },
        {
            name: 'Created Date',
            key: 'CreatedOnFormat',
            sortable: true,
            reorder: true,
            float: "left",
            isSearch: true,
            isExport: true,
            selector: (el) => el?.createdOn,
            format: (el) => el?.CreatedOnFormat
        },
        {
            name: 'Edit',
            isSearch: false,
            isExport: false,
            selector: (el) => <button type='button' className='border-0 p-0 bg-body set_disableclr' disabled={!userRights?.URightEdit}><i className="fa fa-edit" onClick={() => handleEditItem(el)}></i></button>
        },
        {
            name: 'View',
            isSearch: false,
            isExport: false,
            selector: (el) => <button type='button' className='border-0 p-0 bg-body set_disableclr'><i className="fa fa-eye" onClick={() => handleViewItem(el)}></i></button>
        }
    ];
    //#endregion

    //#region table Edit / View functions
    const handleEditItem = (item) => {
        navigate('/SEOConfiguration', { state: { disabled: false, editdisabled: true, mode: 'Update', productId: productId, item: item } });
    }
    const handleViewItem = (item) => {
        navigate('/SEOConfiguration', { state: { disabled: true, editdisabled: true, mode: 'View', productId: productId, item: item } });
    }
    //#endregion




    return (
        <>
            <div className="container-fluid mt-4 heading_color">
                <h3>SEO Panel</h3>
            </div>
            <div className="container-fluid form_border py-5 my-3">

                {/* select product dropdown start */}
                <div className="row">
                    <CustomColumn labelText='Select Product' labelId='ProductId'>
                        <Select
                            className="dropdown select_dropdown"
                            inputId='SupplierId'
                            options={productList}
                            value={productList?.find((prev) => prev?.value === productId) || 0}
                            onChange={(e) => handleOnChange(e ? e?.value : 0)}
                            isSearchable
                            placeholder='Select Product'
                        />
                    </CustomColumn>
                </div>
                {/* select product dropdown end */}

                {/* search text box with button start */}
                <CommonFilter
                    columns={columns}
                    filterList={filterList}
                    searchDisabled={serchdisable}
                    getdata={() => getseopanellist(productId)}
                    setlistdata={setSeoPanelListData}
                    searchvalue={searchValue}
                    setSearchValue={setSearchValue}
                    searchby={searchby}
                    setSerachBy={setSerachBy}
                    isSerachOptionDropdown={false}
                />
                {/* search text box with button end */}

                {/* table listing - show when product is selected start */}
                {
                    productId > 0 &&
                    <CustomTable
                        columns={columns}
                        data={seoPanelListData}
                    />
                }
                {/* table listing - show when product is selected end */}

            </div>
        </>
    )
}

export default SEOPanelList